import { useQuery } from "@tanstack/react-query";

import { tarefaService } from "@/services/api/tarefa.service";
import { TarefaRankingModo, TarefaRankingResponsavelDTO } from "@/types/tarefa.type";

export function useTarefaAdminRankingResponsaveis(
  modo: TarefaRankingModo = "abertas",
  limit = 10,
  dias?: number,
) {
  const { data, isLoading } = useQuery<TarefaRankingResponsavelDTO[]>({
    queryKey: ["tarefa-ranking-responsaveis", modo, limit, dias],
    queryFn: () => tarefaService.getRankingResponsaveisTarefas(modo, limit, dias),
  });

  return { ranking: data ?? [], loading: isLoading };
}
